document.addEventListener("DOMContentLoaded", function () {
  const notifyPopup = document.querySelector(".notify-popup");
  const notifyForm = document.getElementById("stock-notification-form");
  const emailInput = document.getElementById("notification-email");
  const productIdInput = document.getElementById("selected-product-id");
  const subscribeBtn = document.getElementById("subscribe-btn");
  const successMessage = document.querySelector(".subscribe--form-success");

  const productHandle = document.querySelector('meta[property="og:url"]')?.content?.split('/products/')[1]?.replace('/', '');
  
  if (!productHandle) {
    console.error("Product handle not found.");
    return;
  }

  function showPopup(popupId) {
    const popup = document.querySelector(`[data-popup-id="${popupId}"]`);
    if (popup) {
      popup.classList.add("active");
    }
  }

function hidePopup(popupId) {
  const popup = document.querySelector(`[data-popup-id="${popupId}"]`);
  if (popup) {
    popup.classList.remove("active");

    // Reset slider to the beginning
    const slider = popup.querySelector(".slider");
    if (slider) {
      slider.scrollLeft = 0; // Resets the slider to the first item
    }
  }
}


  document.querySelectorAll("[data-popup-trigger]").forEach((triggerButton) => {
    triggerButton.addEventListener("click", function () {
      const popupId = this.getAttribute("data-popup-trigger");
      showPopup(popupId);
    });
  });

  document.querySelectorAll(".popup-close").forEach((closeButton) => {
    closeButton.addEventListener("click", function () {
      console.log("Close button clicked:", this);
      const popup = this.closest("[data-popup-id]");
      if (popup) {
        hidePopup(popup.getAttribute("data-popup-id"));
      } else {
        console.error("No popup found for close button:", this);
      }
    });
  });

  if (subscribeBtn) {
    subscribeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      const email = emailInput.value.trim();
      const productId = productIdInput ? productIdInput.value : "";
      if (!email) {
        console.error("Email field is empty.");
        return;
      }
      fetch(`/products/${productHandle}.json`)
        .then(response => response.json())
        .then(data => {
          const product = data.product;
          const selectedVariant = product.variants.find(variant => variant.id == productId);
          if (!selectedVariant) {
            console.error("Variant not found.");
            return;
          }
          console.log("Variant Data:", selectedVariant);
          if (window.sib) {
            window.sib.track("back_in_stock_subscription", {
              email: email,
              product_id: selectedVariant.id,
              product_name: product.title,
              product_url: window.location.href,
              sku: selectedVariant.sku,
              image_url: selectedVariant.featured_image ? selectedVariant.featured_image.src : ""
            });
            console.log("Brevo event sent:", {
              email: email,
              product_id: selectedVariant.id,
              product_name: product.title,
              product_url: window.location.href,
              sku: selectedVariant.sku,
              image_url: selectedVariant.featured_image ? selectedVariant.featured_image.src : ""
            });
            successMessage.style.display = "block";
            notifyForm.style.display = "none";
            setTimeout(() => {
              successMessage.style.display = "none";
              hidePopup("notify-popup");
            }, 3000);
            emailInput.value = "";
          } else {
            console.error("Brevo Tracker not loaded.");
          }
        })
        .catch(error => console.error("Error fetching product data:", error));
    });
  }

  // Added: Set window height for responsive popup
  function setWindowHeight() {
    document.documentElement.style.setProperty('--window-height', `${window.innerHeight}px`);
  }
  window.addEventListener('load', setWindowHeight);
  window.addEventListener('resize', setWindowHeight);
});